import { stats } from '@/mocks/posts';

export default function StatsStrip() {
  return (
    <section className="w-full px-4 md:px-8" aria-label="网站数据">
      <div className="grid grid-cols-2 gap-4 rounded-lg bg-foreground-950 px-6 py-8 lg:grid-cols-4">
        {stats.map((item) => (
          <div key={item.label} className="text-center">
            <p className="font-heading text-3xl font-bold text-accent-400 md:text-4xl">
              {item.value}
              <span className="ml-1 text-base font-medium text-background-300">{item.unit}</span>
            </p>
            <p className="mt-2 text-xs text-background-300 md:text-sm">{item.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}